interface RoleNameValidationRole {
    id: string;
    name: string;
}

const normalizeRoleName = (roleName: string) => roleName.trim().toUpperCase();

export const hasVisibleDuplicateRoleNameError = ({
    existingRoles,
    currentRoleId,
    roleName,
    isSaving,
}: {
    existingRoles: RoleNameValidationRole[];
    currentRoleId: string;
    roleName: string;
    isSaving: boolean;
}) => {
    if (isSaving) {
        return false;
    }

    const normalizedRoleName = normalizeRoleName(roleName);
    if (!normalizedRoleName) {
        return false;
    }

    return existingRoles.some(existingRole =>
        existingRole.id !== currentRoleId
        && normalizeRoleName(existingRole.name) === normalizedRoleName
    );
};
